export const fileupload = {
  root: {
    background: "{surface.bg-white}",
    borderColor: "{surface.border}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}",
  },
  header: {
    background: "transparent",
    color: "{text.body}",
    padding: "{padding.16}",
    borderColor: "unset",
    borderWidth: "0",
    borderRadius: "0",
    gap: "{gap.8}",
  },
  content: {
    highlightBorderColor: "{primary.default}",
    padding: "{padding.16}",
    gap: "{gap.16}",
  },
  file: {
    padding: "{padding.16}",
    gap: "{gap.16}",
    borderColor: "{surface.border-danger}",
    info: {
      gap: "{gap.8}",
    },
  },
  fileList: {
    gap: "{gap.8}",
  },
  progressbar: {
    height: "4px",
  },
  basic: {
    gap: "{gap.8}",
  },
  css: (): string => `
    .p-fileupload p-progressbar,
    .p-fileupload-file-list {
      display: none;
    }
  `,
};
